export default [
    {
      title: 'Developer API',
      route: 'developer-api',
      icon: 'CodeIcon',
    }
]